import { render } from "./ComboBox.vue?vue&type=template&id=47c1d340"
import script from "./ComboBox.vue?vue&type=script&lang=js"
export * from "./ComboBox.vue?vue&type=script&lang=js"

import "./ComboBox.vue?vue&type=style&index=0&id=47c1d340&lang=scss"

import exportComponent from "/home/rubb/NiwCaetano/Frontend/governance/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__